/* eslint-disable no-console */
import { Logger, LogType, Transport } from '@hitiq/logger';
import { injectable } from 'inversify';

@injectable()
export class ConsoleLogger implements Logger {
  log(type: LogType, message: string): void {
    switch (type) {
      case LogType.silly:
      case LogType.debug:
      case LogType.verbose:
        console.debug(message);
        break;
      case LogType.info:
      case LogType.http:
        console.info(message);
        break;
      case LogType.warn:
        console.warn(message);
        break;
      case LogType.error:
        console.error(message);
        break;
      default:
        break;
    }
  }

  createLogger(level: LogType, transports: Transport[]): void {
    throw new Error('Not Implemented for Console');
  }

  addTransport(transport: Transport): void {
    throw new Error('Not Implemented for Console');
  }

  removeTransport(transport: Transport) {
    throw new Error('Not Implemented for Console');
  }
}
export {};
